import LaneFeesFormCopy from 'app/Apps/Pricing/LaneFees/LaneFeesFormCopy'
import LaneFeesFormUpdate from 'app/Apps/Pricing/LaneFees/LaneFeesFormUpdate'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'

export default function LaneFeesFormOverview({
    id,
}: Readonly<{ id: number, onSuccess: (value: { id: number }) => void }>) {
    const {
        LaneFees: LaneFeesRoutes,
    } = usePricingRoutes()

    return useSkyNetRoutes({
        routes: [
            {
                path: CommonRoutes.Slash,
                element: <LaneFeesFormUpdate
                    id={id}
                    disabled
                />,
            },
            {
                path: LaneFeesRoutes.Copy.stringParams,
                element: <LaneFeesFormCopy />,
            },
        ],
    })
}
